import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserInformation } from '../models/user-information';
import { GLOBAL } from '../services/global';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';
//import { CookieService } from 'angular2-cookie/services/cookies.service';
@Component({
  selector: 'main-panel',
  templateUrl: '../views/main-panel.html'
})
export class MainPanelComponent
{
  public title: string;
  public levelAccess: number;
  public user_id:number;

  public constructor(
                      private _route: ActivatedRoute,
                      public sharedVariables: VariableService,
                    //  private cookie: CookieService
                    ) {
    this.title = "Bienvenido";
  }

  ngOnInit()
  {
    console.log(this.sharedVariables.getCookie('username'));
    console.log(this.sharedVariables);
    this.sharedVariables.validSession();
    setTimeout(()=> {
                      if(this.sharedVariables.login){

                      }
                      else
                        this.title = "Error, Sesión no iniciada";
                    },this.sharedVariables.sessionTime);
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.user_id = response.data[0].id;
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/main-panel.component.ts